<template>
  <div id="leftSidebar" :class="{'active': sidebarActive}">
    <div class="card">
      <div class="card-header">
        <ul class="row">
          <li :class="['col-xs-12', { 'active': isSelect === 'input'  }]" @click="isSelect = 'input'">조건</li>
        </ul>
      </div>
      <div :class="['card-body', { 'full-card-body': isSelect !== 'input' }]">
        <div id="profitCondition" v-show="isSelect === 'input'">
          <div class="collapse-group">
            <div class="collapse-title" data-toggle="collapse" data-target="#basicCondition" aria-expanded="true" aria-controls="basicCondition">
              공통정보 <i class="glyphicon glyphicon-triangle-bottom pull-right"></i>
            </div>
            <div class="collapse in" id="basicCondition" aria-expanded="true">
              <div class="row form-group">
                <label class="col-sm-5">
                  파워플래너 아이디
                </label>
                <div class="col-sm-7">
                  {{ data.pp_id }}
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-5">
                  파워플래너 비밀번호
                </label>
                <div class="col-sm-7">
                  {{ data.pp_pw }}
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-5">
                  고객명
                </label>
                <div class="col-sm-7">
                  {{ data.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="collapse-group" >
            <div class="collapse-title" data-toggle="collapse" data-target="#additionalInfo" aria-expanded="true" aria-controls="additionalInfo">
              전력정보 <i class="glyphicon glyphicon-triangle-bottom pull-right"></i>
            </div>
            <div class="collapse in" id="additionalInfo" aria-expanded="true">
              <div class="row form-group">
                <label class="col-sm-4">
                  수요관리 계약용량
                </label>
                <div class="col-sm-8">
                  <input type="number"
                         class="hz-input-default hz-input-md"
                         v-model="data.dr_capacity"
                  >
                  <span class="hz-unit">kW</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  수요관리 정산율
                </label>
                <div class="col-sm-8">
                  <input type="number"
                         class="hz-input-default hz-input-md"
                         v-model="data.dr_payment_rate"
                  >
                  <span class="hz-unit">%</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  자발적DR 낙찰률
                </label>
                <div class="col-sm-8">
                  <input type="number"
                         class="hz-input-default hz-input-md"
                         v-model="data.dr_winning_rate"
                  >
                  <span class="hz-unit">%</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  분석기준일자
                </label>
                <div class="col-sm-8">
                  <date-picker :size="'hz-picker-md'"
                               :placeholder="'분석기준일자를 입력 해 주세요..'"
                               v-model="data.specific_date"
                               :options="{max: data.date_max, min: data.date_min}"
                  >
                  </date-picker>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  목표전력 설정
                </label>
                <div class="col-sm-8">
                  <input type="number"
                         class="hz-input-default hz-input-md"
                         v-model="data.target_peak"
                  >
                  <span class="hz-unit">kW</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="list" v-show="isSelect === 'list'">
          <ul>
            <li class="main">수요관리 분석결과</li>
            <li class="sub border">참여조건 검토 (RRMSE 검증)</li>
            <li class="main">예상 수익</li>
            <li class="main">예상 절감효과</li>
          </ul>
        </div>
      </div>
      <div v-if="isSelect === 'input'" class="card-footer">
        <button class="hz-btn-primary hz-btn-lg" style="border-radius: initial;" @click="setAdjust()">적용</button>
      </div>
    </div>
    <a href="#" class="toggle" @click.prevent="toggleMenu()">
      <i :class="['glyphicon', toggleIconClass]" style="font-size: 12px; font-weight: normal;"></i>
    </a>
  </div>
</template>

<script>
import Tooltip from 'common/components/Tooltip'
// import eventHub from '@/shared/EventHub'
import conditionTooltip from '@/assets/js/condition-tooltip.js'
import DatePicker from 'common/components/DatePicker'
import { mapGetters } from 'vuex'

export default {
  name: 'left-sidebar-epa',
  components: {
    Tooltip,
    DatePicker
  },
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    sidebarActive: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      isSelect: 'input',
      dataSetDone: false,
      data: {
        id: '',
        pp_id: '',
        pp_pw: '',
        name: '',
        dr_capacity: '',
        dr_payment_rate: '',
        dr_winning_rate: '',
        specific_date: '',
        target_peak: '',
        date_max: '',
        date_min: ''
      },
      tooltipObj: conditionTooltip
    }
  },
  computed: {
    ...mapGetters({
      user: 'user',
      condition: 'condition',
      isPaidMember: 'isPaidMember'
    }),
    isStaff () {
      return this.user.auth_level === '90'
    },
    toggleIconClass () {
      return this.sidebarActive ? 'glyphicon-menu-left' : 'glyphicon-menu-right'
    }
  },
  watch: {
    'sidebarActive': {
      handler (val) {
        const isPcScreen = this.$parent.checkScreenWidth()

        // PC 스크린이 아닐 경우에만 실행한다. (1200px 미만)
        if (!isPcScreen) {
          const isHidden = val ? 'hidden' : ''
          this.setOverflow(isHidden)
        }
      }
    }
  },
  methods: {
    setAdjust () {
      this.$emit('setCondition', this.data)
      this.toggleMenu()
    },
    setOverflow (state = 'auto') {
      /**
       *  컨텐츠에 스크롤을 제어합니다.
       *  사이드바 활성화 여부에 따라 body에 overflow 속성을 할당해줍니다.
       *  사이드바 활성화 시 overflow 비활성화
       *  사이브다 비활성화 시 overflow 활성화
       */
      document.getElementsByTagName('body')[0].setAttribute('style', `overflow: ${state};`)
    },
    toFixed: _.debounce(function (field, value, size = 3) {
      /**
       * input type = number인 필드에 값이 입력 될 때 호출되는 함수입니다.
       * 최종 이벤트 발생 후 1초뒤에 실행합니다.
       * 입력이 공백 일 경우 0을 자동으로 반환합니다.
       * 입력 된 수에 소수점 자릿수를 잘라 반환합니다.
       */

      const vm = this
      const number = isNaN(parseFloat(value)) ? 0 : parseFloat(parseFloat(value).toFixed(size))

      // 해당 필드에 데이터 Set
      vm.$set(vm.data.oneclick_profit_condition, field, number)
    }, 300),
    toggleMenu (target = '') {
      this.$parent.sidebarActive = target ? true : !this.sidebarActive
    }
  },
  created () {
    // 컴포넌트 데이터 초기화
    this.data = {
      ...this.value,
      date_max: moment(new Date()).format('YYYY.MM.DD'),
      date_min: moment(this.value.pp_end).subtract(4, 'months').format('YYYY.MM.DD')
    }
    this.$nextTick(() => {
      this.dataSetDone = true
    })
  },
  beforeDestroy () {
    // 페이지 이동 시 스크롤을 활성화
    this.setOverflow()
  }
}
</script>

<style lang="scss" scoped>
$left-sidebar-width: 400px;
$hide-position: -400px;
$grey-bg-color: #f7f9fa;
$box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.16), 0 1px 1px 0 rgba(0, 0, 0, 0.23);
$active-color: #26507a;

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

input,
textarea {
  width: 100%;
  padding: 16px;
}

#leftSidebar {
  width: $left-sidebar-width;
  height: 100%;
  position: fixed;
  top: 64px;
  left: $hide-position;
  background-color: $hzc-white;
  z-index: 9;
  transition: all .5s ease;

  &.active {
    left: 0;
    .toggle {
      left: 399px;
    }
  }

  @media (max-width: 767px) {
    width: calc(100% - 40px);
    left: calc(-100% + 40px);

    &.active .toggle {
      left: calc(100% - 1px);
      opacity: 1;
    }
  }

  .card {
    width: 100%;
    height: 100%;
    overflow: hidden;
    box-shadow: $z-depth-01;
    float: left;

    .card-header {
      border-width: 0 1px 1px 0;
      border-style: solid;
      border-color: $hzc-gray-04;

      ul {
        box-shadow : 0 1px 1px 0 rgba(0,0,0,.16), 0 1px 1px 0 rgba(0,0,0,.23);
      }

      li {
        height: 48px;
        display: inline-block;
        text-align: center;
        line-height: 48px;
        font-size: 14px;
        color: $hzc-gray-06;
        cursor: pointer;

        &.active,
        &:hover {
          color: $active-color;
          border-bottom: 4px solid $active-color;
        }
      }
    }

    .card-body {
      height: calc(100% - 160px);
      overflow-x: hidden;
      overflow-y: auto;
      border-right: 1px solid $hzc-gray-04;
    }

    .card-footer {
      height: 48px;

      button {
        width: 100%;
      }
    }

    .full-card-body {
      height: calc(100% - 112px);

      @media (max-width: 991px) {
        height: calc(100% - 110px);
      }
    }

    .form-group {
      label {
        margin: 0;
        font-size: 14px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        color: $header-color;
        line-height: 32px;
      }

      .col-sm-7 {
        position: relative;
        top: 7px;

        @media (max-width: 767px) {
          top: 0
        }
      }
    }

    .condition-tooltip {
      float: right;
    }
  }

  .toggle {
    position: absolute;
    top: calc(50% - 96px);
    width: 25px;
    height: 48px;
    line-height: 48px;
    font-size: 14px;
    color: $hzc-gray-07;
    text-align: center;
    background-color: $hzc-white;
    border-width: 1px 1px 1px 0;
    border-style: solid;
    border-color: $hzc-gray-04;
    box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.12);
    float: left;

    @media (max-width: 767px) {
      opacity: 0.75;
    }
  }

  .hz-picker-md .k-input {
    padding: 0 4px;
  }
}

#profitCondition {
  height: 100%;
  width: 100%;

  .collapse-group {
    display: block;
    width: 100%;
    height: auto;
    background-color: $hzc-white;
    cursor: pointer;
  }

  .collapse-title {
    height: 100%;
    padding: 0 16px;
    background-color: $hzc-white;
    border-width: 1px 0 1px 1px;
    border-style: solid;
    border-color: $hzc-gray-03;
    line-height: 48px;
    &:hover { background-color: darken($hzc-white, 10%); }
    &:active { background-color: darken($hzc-white, 20%); }
  }

  .collapse {
    width: 100%;
  }

  .form-group {
    display: inline-block;
    width: 100%;
    margin: 4px 0;
    padding: 0 16px;

    &:first-child {
      margin: 16px 0 4px;
    }

    &:last-child {
      margin: 4px 0 16px;
    }

    label {
      margin: 0;

      &.related-field {
        color: $hzc-gray-05;
      }

      @media (max-width: $screen-xs-max) {
        width: 144px;
      }
    }

    .col-sm-4 {
      padding: 0 8px 0 0;
    }

    .col-sm-8,
    .col-xs-6 {
      padding: 0;
    }

    .hz-btn-default {
      width: 100%;
      line-height: 30px;
      border-left: none;
      font-size: 12px;
    }

    .hz-unit {
      position: absolute;
      top: 9px;
      right: 16px;
      font-size: 12px;
      font-weight: bold;
      color: $hzc-gray-05;
    }
  }

  .recent-input-price {
    position: absolute;
    width: 100%;
    height: auto;
    max-height: 250px;
    overflow: auto;
    margin-top: 4px;
    border-radius: 4px;
    -webkit-box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.13);
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.13);
    background-color: $hzc-white;
    text-align: left;
    z-index: 7;

    ul {
      overflow: auto;
    }

    li {
      position: relative;
      padding: 4px 8px;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: -0.35px;
      color: $font-color;
    }

    li:first-child {
      padding-top: 8px;
    }

    li:last-child {
      padding-bottom: 8px;
    }

    li:hover {
      background-color: #f5f2fc;
      color: $purple;
    }
  }

  .glyphicon-triangle-bottom {
    top: 0;
    line-height: 48px;
    font-size: 9px;
  }
}

#list {
  height: 100%;
  width: 100%;

  ul {
    li {
      &.main {
        padding: 16px;
        border-bottom: 1px solid #dee2e6;
        font-size: 14px;
        font-weight: bold;
      }

      &.sub {
        padding: 8px 16px;
        font-size: 14px;

        &.border {
          border-bottom: 1px solid #dee2e6;
        }
      }

      &:hover {
        background-color: #f4f6fa;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EpaSidebar.vue